/**
 * /search page tab-selection persistence (Phase 8)
 *
 * Remembers which tab (Products / Blogs / Recipes) the user was last
 * on within this browser tab (sessionStorage — per-tab, cleared on
 * tab close). Restores after every filter re-render + on page reload.
 *
 * Why: theme's FacetFiltersForm.renderProductGridContainer replaces
 * #ProductGridContainer.innerHTML on every filter apply, which resets
 * the CSS-radio tabs back to Products (Liquid default). Persisting +
 * restoring on the render hook keeps the user on the tab they were on.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'aro-search-page-tab';
  var VALID_TABS = ['products', 'blogs', 'recipes'];

  function read() {
    try {
      var v = sessionStorage.getItem(STORAGE_KEY);
      return VALID_TABS.indexOf(v) !== -1 ? v : null;
    } catch (e) { return null; }
  }

  function write(v) {
    try { sessionStorage.setItem(STORAGE_KEY, v); } catch (e) { /* silent */ }
  }

  function restoreTab() {
    var tab = read();
    if (!tab) return;
    var radio = document.getElementById('aro-search-page-tab-' + tab);
    if (radio && !radio.checked) radio.checked = true;
  }

  function bindTabChanges() {
    document.querySelectorAll('input[name="aro-search-page-tab"]').forEach(function (r) {
      if (r.__aroBound) return;
      r.__aroBound = true;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var tab = r.id.replace('aro-search-page-tab-', '');
        if (VALID_TABS.indexOf(tab) !== -1) write(tab);
      });
    });
  }

  function init() {
    restoreTab();
    bindTabChanges();
  }

  function hookRerender() {
    if (!window.FacetFiltersForm) return false;
    if (FacetFiltersForm.__aroTabsHooked) return true;
    FacetFiltersForm.__aroTabsHooked = true;
    var orig = FacetFiltersForm.renderProductGridContainer;
    if (typeof orig !== 'function') return true;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      orig.call(this, html);
      try { init(); } catch (e) { /* silent */ }
    };
    return true;
  }

  function bootstrap() {
    init();
    if (!hookRerender()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (hookRerender() || tries > 40) clearInterval(iv);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
